import base64 from 'base64-js';
import { TextDecoder } from 'text-encoding-shim';

const base64Decode = (str) => {
  const bytes = base64.toByteArray(str);
  return new TextDecoder().decode(bytes);
};

export default base64Decode;
